// src/utils/time/timestamp.ts
function timestamp() {
  const origin = performance.timeOrigin;
  const elapsed = performance.now();
  const date = new Date(origin + elapsed);
  const microseconds = parseInt(
    /**
     * Performance.now return value.
     * ```
     * 123    . 123     4567
     * millis . micros  floating point others
     * ```
     *
     * Multiplying by `1000` converts the timestamps from milliseconds to microseconds.
     *
     * Adding origin time to elapsed, because elapsed might not have the full 6-digit fidelity for microseconds as required by the API.
     */
    Math.floor(origin * 1e3 + elapsed * 1e3).toString().slice(-6),
    10
  );
  return {
    /** The ISO-8601 date time string. */
    iso: date.toISOString(),
    /** The microseconds in which the time stamp was created. */
    microseconds,
    /** Unix milliseconds since 1970 or whatever caused Y2K. */
    unix: date.getTime()
  };
}

export {
  timestamp
};
